// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\home\\\\SupportSection\\\\components\\\\SupportTile.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\home\\SupportSection\\components\\SupportTile.tsx");
  import.meta.hot.lastModified = "1757171103323.9631";
}
// REMIX HMR END

import { cn } from "~/lib/utils";
export function SupportTile({
  icon,
  title,
  description,
  href,
  className
}) {
  const Component = href ? "a" : "div";
  return <Component href={href} className={cn("group relative flex flex-col items-left justify-center p-6 lg:p-12 ", "border border-white/20 rounded-lg", "transition-all duration-300", "hover:border-white/40 hover:bg-white/5", "h-[200px]", className)}>
      <div className="flex flex-col items-left space-y-2">
        <div className="text-white/80 transition-transform duration-300 group-hover:scale-105">
          {icon}
        </div>
        <h3 className="text-heading-4 transition-transform duration-300 group-hover:scale-105">
          {title}
        </h3>
      </div>
    </Component>;
}
_c = SupportTile;
var _c;
$RefreshReg$(_c, "SupportTile");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;